 export const DeployType = {
  prod: true,
  version : 1.0
 }